import React, { useContext } from 'react';
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";
import PageHero from "./common/PageHero";
import CtaBand from "./common/CtaBand";

const Assistance = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    const features = [
        {
            icon: 'fas fa-landmark',
            title: de ? 'Behördengänge & Formalitäten' : 'Autoridades & formalidades',
            text: de
                ? 'Wir bereiten alle erforderlichen Unterlagen vor, übernehmen die Kommunikation mit Behörden und behalten Fristen im Blick – von der Gewerbeanmeldung über Genehmigungen bis zur steuerlichen Registrierung.'
                : 'Preparamos todos os documentos necessários, tratamos da comunicação com as autoridades e controlamos os prazos – do registo comercial às licenças e registos fiscais.'
        },
        {
            icon: 'fas fa-rocket',
            title: de ? 'Unternehmensgründung' : 'Criação de empresas',
            text: de
                ? 'Von der Wahl der richtigen Rechtsform über den Businessplan bis zu allen administrativen Aufgaben – gemeinsam mit erfahrenen Steuerberatern und Anwälten in Deutschland und Portugal.'
                : 'Da escolha da forma jurídica correta ao plano de negócios e a todas as tarefas administrativas – em conjunto com consultores fiscais e advogados experientes na Alemanha e em Portugal.'
        },
        {
            icon: 'fas fa-globe-europe',
            title: de ? 'Internationale Expansion' : 'Expansão internacional',
            text: de
                ? 'Umzug nach Portugal oder Zweigstelle in Deutschland? Wir kümmern uns um steuerliche, rechtliche und organisatorische Fragen, übersetzen Dokumente und kommunizieren in der Landessprache.'
                : 'Mudança para Portugal ou sucursal na Alemanha? Tratamos das questões fiscais, jurídicas e organizacionais, traduzimos documentos e comunicamos na língua local.'
        },
        {
            icon: 'fas fa-file-signature',
            title: de ? 'Versicherungen & Kontakte' : 'Seguros & contactos',
            text: de
                ? 'Wir unterstützen Sie bei der Auswahl passender Versicherungen, knüpfen Kontakte zu potenziellen Kunden und Geschäftspartnern und verbinden Sie mit Steuerberatern und Anwälten.'
                : 'Apoiamo-lo na seleção de seguros adequados, estabelecemos contactos com potenciais clientes e parceiros e ligamo-lo a consultores fiscais e advogados.'
        },
        {
            icon: 'fas fa-users',
            title: de ? 'Personalbeschaffung & -anmeldung' : 'Recrutamento & registo',
            text: de
                ? 'Wir helfen bei der Suche nach geeignetem Personal und übernehmen die Anmeldung bei den zuständigen Behörden – unter Einhaltung aller rechtlichen Vorgaben.'
                : 'Ajudamos a encontrar pessoal adequado e tratamos do registo junto das autoridades competentes – cumprindo todos os requisitos legais.'
        },
        {
            icon: 'fas fa-language',
            title: de ? 'Sprachunterstützung & Übersetzung' : 'Apoio linguístico & tradução',
            text: de
                ? 'Deutsch und Portugiesisch aus einer Hand: Wir übersetzen Dokumente und begleiten Gespräche – damit Sprache nie zum Hindernis wird.'
                : 'Alemão e português de uma só fonte: traduzimos documentos e acompanhamos conversas – para que a língua nunca seja um obstáculo.'
        }
    ];

    return (
        <main>
            <PageHero
                eyebrow={de ? 'Leistung 02 — Hilfestellungen' : 'Serviço 02 — Apoio'}
                title={de
                    ? <span>Ihr Wegbegleiter für <em>reibungslose Abläufe</em>.</span>
                    : <span>O seu companheiro para <em>processos sem problemas</em>.</span>}
                lede={de
                    ? 'Ob Behördengänge, Unternehmensgründung oder die Beschaffung wichtiger Ressourcen – wir stehen Ihnen mit Erfahrung, Know-how und einem starken Netzwerk zur Verfügung. Alles aus einer Hand.'
                    : 'Quer se trate de questões oficiais, da criação de uma empresa ou da obtenção de recursos importantes – estamos à sua disposição com experiência, conhecimento e uma forte rede. Tudo de uma só fonte.'}
            />

            <section className="tm-section">
                <div className="tm-container">
                    <div className="tm-section__head">
                        <span className="tm-eyebrow">{de ? 'Unsere Hilfestellungen' : 'O nosso apoio'}</span>
                        <h2 className="tm-section__title">
                            {de
                                ? <span>So vielseitig wie <em>Ihre Herausforderungen</em>.</span>
                                : <span>Tão versátil como <em>os seus desafios</em>.</span>}
                        </h2>
                    </div>
                    <div className="tm-features">
                        {features.map((f, i) => (
                            <div key={i} className="tm-feature">
                                <span className="tm-feature__icon"><i className={f.icon}/></span>
                                <h3>{f.title}</h3>
                                <p>{f.text}</p>
                            </div>
                        ))}
                    </div>

                    <div className="tm-callout" style={{ marginTop: "56px" }}>
                        <i className="fas fa-check-circle"/>
                        <div>
                            <h3>{de ? 'Ihr Vorteil: alles aus einer Hand' : 'A sua vantagem: tudo de uma só fonte'}</h3>
                            <p>
                                {de
                                    ? 'Mit unserem Hilfestellungsservice erhalten Sie alle Leistungen, die Sie benötigen, um Herausforderungen souverän zu meistern. Unser Ziel: Ihnen den Weg ebnen, damit Sie sich auf Ihr Kerngeschäft konzentrieren können.'
                                    : 'Com o nosso serviço de apoio, recebe todos os serviços de que necessita para dominar os desafios com confiança. O nosso objetivo: abrir-lhe o caminho para que se possa concentrar na sua atividade principal.'}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <CtaBand/>
        </main>
    );
};

export default Assistance;



// WEBPACK FOOTER //
// ./src/components/Assistance.js